export default __webpack_public_path__ + "static/media/eq1.b7ee195c.svg";